import TvPlaylistState from 'app/routes/tv/types/TvPlaylistState';
import Video from 'app/components/tv/models/video';

export type PlaylistFetchingAction = {type: PlaylistActionType.PLAYLIST_FETCHING};

export type PlaylistUpdateAction = {
  type: PlaylistActionType.PLAYLIST_UPDATE;
  data: {playlist: TvPlaylistState['playlist']; currentVideo: TvPlaylistState['currentVideo']};
};

export type AddPlaylistVideoAction = {
  type: PlaylistActionType.ADD_PLAYLIST_VIDEO;
  data: Video;
};

export type CurrentVideoUpdateAction = {
  type: PlaylistActionType.CURRENT_VIDEO_UPDATE;
  data: Video;
};

export type TvPlaylistAction =
  | PlaylistFetchingAction
  | PlaylistUpdateAction
  | AddPlaylistVideoAction
  | CurrentVideoUpdateAction;

export enum PlaylistActionType {
  PLAYLIST_FETCHING = 'PLAYLIST_FETCHING',
  PLAYLIST_UPDATE = 'PLAYLIST_UPDATE',
  ADD_PLAYLIST_VIDEO = 'ADD_PLAYLIST_VIDEO',
  CURRENT_VIDEO_UPDATE = 'CURRENT_VIDEO_UPDATE',
}
